const productData = {
    "products": [
      {
        "id": 1,
        "name": "Classic Blue Jeans & White T-shirt Combo",
        "price": 89.99,
        "rating": 4.7,
        "image": "../Images/feat1.png",
        "category": "Jean & T-shirt",
        "description": "A timeless combination of comfortable blue jeans and a crisp white t-shirt. Perfect for casual outings.",
        "liked": false
      },
      {
        "id": 2,
        "name": "Floral Summer Dress",
        "price": 65.50,
        "rating": 4.5,
        "image": "../Images/feat2.png",
        "category": "Dress",
        "description": "A light and breezy floral dress, ideal for warm summer days. Features a flattering A-line cut.",
        "liked": false
      },
      {
        "id": 3,
        "name": "Leather Biker Jacket",
        "price": 199.99,
        "rating": 4.8,
        "image": "../Images/feat3.png",
        "category": "Jacket",
        "description": "A stylish and durable leather jacket, perfect for adding an edge to any outfit. Features multiple pockets and a comfortable fit.",
        "liked": false
      },
      {
        "id": 4,
        "name": "Elegant Pencil Skirt & Blouse Set",
        "price": 120.00,
        "rating": 4.6,
        "image": "../Images/feat4.png",
        "category": "Skirt & Blouse",
        "description": "A sophisticated set featuring a sleek pencil skirt paired with a complementary blouse. Ideal for office wear or formal events.",
        "liked": false
      },
      {
        "id": 5,
        "name": "Casual Khaki Shorts & Polo Shirt Combo",
        "price": 75.99,
        "rating": 4.4,
        "image": "../Images/feat5.png",
        "category": "Jean & T-shirt",
        "description": "A comfortable and stylish combination for warm weather. Includes well-fitted khaki shorts and a breathable polo shirt.",
        "liked": false
      },
      {
        "id": 6,
        "name": "Bohemian Maxi Dress",
        "price": 89.95,
        "rating": 4.7,
        "image": "../Images/feat6.png",
        "category": "Dress",
        "description": "A flowing, patterned maxi dress with a bohemian flair. Perfect for beach vacations or summer festivals.",
        "liked": false
      },
      {
        "id": 7,
        "name": "Waterproof Windbreaker Jacket",
        "price": 110.00,
        "rating": 4.5,
        "image": "../Images/feat7.png",
        "category": "Jacket",
        "description": "A lightweight, waterproof jacket perfect for unpredictable weather. Comes with a hood and multiple pockets.",
        "liked": false
      },
      {
        "id": 8,
        "name": "Professional Blazer & Trouser Set",
        "price": 189.99,
        "rating": 4.8,
        "image": "../Images/feat8.png",
        "category": "Skirt & Blouse",
        "description": "A sharp and professional set including a well-tailored blazer and matching trousers. Ideal for business meetings and formal occasions.",
        "liked": false
      },
      
     
    ],
    "newCollection": [
      {
        "id": 20,
        "name": "Skirt & Blouse",
        "price": 115.00,
        "rating": 4.5,
        "image": "../Images/newest1.png",
        "category": "Skirt & Blouse",
        "description": "A stylish set featuring an A-line skirt paired with a peplum blouse. Perfect for a polished and sophisticated look.",
        "liked": false
      },
      {
        "id": 21,
        "name": "Cargo Pants & Henley Shirt Combo",
        "price": 99.99,
        "rating": 4.4,
        "image": "../Images/newest2.png",
        "category": "Jean & T-shirt",
        "description": "A rugged yet stylish combination of cargo pants and a comfortable Henley shirt. Perfect for outdoor activities or casual wear.",
        "liked": false
      },
      {
        "id": 22,
        "name": "Shift Dress",
        "price": 75.50,
        "rating": 4.5,
        "image": "../Images/newest3.png",
        "category": "Dress",
        "description": "A classic shift dress that offers both comfort and style. Versatile enough for both office wear and casual outings.",
        "liked": false
      },
      {
        "id": 23,
        "name": "Parka Jacket",
        "price": 179.99,
        "rating": 4.8,
        "image": "../Images/newest4.png",
        "category": "Jacket",
        "description": "A warm and stylish parka jacket, perfect for cold weather. Features a faux fur-lined hood and multiple pockets.",
        "liked": false
      },
      {
        "id": 24,
        "name": "Tulle Skirt & Crop Top Set",
        "price": 125.00,
        "rating": 4.6,
        "image": "../Images/newest5.png",
        "category": "Skirt & Blouse",
        "description": "A playful and trendy combination featuring a tulle skirt paired with a fashionable crop top. Ideal for parties and special occasions.",
        "liked": false
      },
      {
        "id": 25,
        "name": "Boyfriend Jeans & Oversized Tee Combo",
        "price": 92.50,
        "rating": 4.3,
        "image": "../Images/newest6.png",
        "category": "Jean & T-shirt",
        "description": "A relaxed and comfortable outfit featuring loose-fitting boyfriend jeans paired with an oversized tee. Perfect for a laid-back, effortless look.",
        "liked": false
      },
      {
        "id": 26,
        "name": "Wrap Dress",
        "price": 85.99,
        "rating": 4.7,
        "image": "../Images/newest7.png",
        "category": "Dress",
        "description": "A flattering wrap dress suitable for various body types. Features a tie waist and V-neckline for a feminine touch.",
        "liked": false
      },
      {
        "id": 27,
        "name": "Trench Coat",
        "price": 169.95,
        "rating": 4.9,
        "image": "../Images/newest8.png",
        "category": "Jacket",
        "description": "Embody Hot Pink Cut Out Twist Front Ruched Midi Dress.",
        "liked": false
      },
    ],
     "tShirts": [
      {
          "id": 30,
          "name": "T-shirt",
          "price": 25.00,
          "rating": 4.5,
          "image": "../Images/tshirt.jpg",
          "category": "T-shirt",
          "description": "A classic black t-shirt made from soft and breathable cotton. Versatile enough to be paired with any outfit.",
          "liked": false
        },
        {
          "id": 31,
          "name": "Trouser",
          "price": 30.00,
          "rating": 4.2,
          "image": "../Images/trouser.png",
          "category": "T-shirt",
          "description": "A trendy graphic print tee that adds a pop of color to your wardrobe. Made from high-quality, durable fabric.",
          "liked": false
        },
        {
          "id": 32,
          "name": "Jacket",
          "price": 35.00,
          "rating": 4.6,
          "image": "../Images/jacket.png",
          "category": "T-shirt",
          "description": "A classic striped polo shirt that offers both style and comfort. Features a ribbed collar and sleeve cuffs.",
          "liked": false
        },
        {
          "id": 33,
          "name": "Dress",
          "price": 28.50,
          "rating": 4.4,
          "image": "../Images/feat6.png",
          "category": "T-shirt",
          "description": "A versatile V-neck jersey top that can be dressed up or down. Made from a soft and stretchy fabric for a comfortable fit.",
          "liked": false
        },
        {
          "id": 34,
          "name": "Skirt",
          "price": 32.99,
          "rating": 4.3,
          "image": "../Images/skirt.png",
          "category": "T-shirt",
          "description": "A casual long sleeve Henley shirt that is perfect for layering. Features a button-up neckline and a relaxed fit.",
          "liked": false
        },


      ]
  };

  export default productData;